module.exports = "<footer>\r\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 foot\">\r\n      © {{year}} GEODIS All rights reserved.\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.html
// module id = ./src/app/components/shared/footer/footer.component.html
// module chunks = main